import { collaborationApi } from 'Api/index';
import { store } from 'Store/store.index';
import { getAnnotFromXFDF, filterAnnotationData, getAnnotRenderInfo, annotExportToJSON} from '@/utils/sdk_utils';
import intl from "react-intl-universal"
import { sendNotificationWithinTeams } from '@/modules/msTeams/services/notification';

let updateAnnotShake = null
let startAnnotTaskFlag = null
const annotTypeSubjectMap = {
  "FreeTextTypewriter": 'Typewriter',
  "FreeTextCallout": 'Callout',
  "Textbox": 'Textbox',
  "Replace": 'Replace Text',
}
const annotTypeIndentMap = {
  "LineArrow": 'Arrow',
  "PolygonCloud": 'Cloud',
  "LineDimension": 'Distance',
  "PolyLineDimension": 'Perimeter',
  "PolygonDimension": 'Area',
  "CircleDimension": 'Area'
}
const annotTypeMap = {
  "highlight": 'Highlight',
  "strikeout": 'Strikeout',
  "underline": 'Underline',
  'squiggly': 'Squiggly Underline',
  "caret": 'Insert Text',
  "square": 'Rectangle',
  "circle": 'Oval',
  "line": 'Line',
  "polygon": 'Polygon',
  "polyline": 'Polyline',
  "ink": 'Pencil',
  "stamp": 'Stamp',
  "link": 'link',
  "fileattachment": 'FileAttachment',
}
const annotNumberMap = {
  'Highlight': 1,
  'Squiggly Underline': 2,
  'Underline': 3,
  'Strikeout': 4,
  'Replace Text': 5,
  'Insert Text': 6,
  'Note': 7,
  'Typewriter': 8,
  'Callout': 9,
  'Textbox': 10,
  'Rectangle': 11,
  'Cloud': 12,
  'Polyline': 13,
  'Oval': 14,
  'Arrow': 15,
  'Polygon': 16,
  'Line': 17,
  'Pencil': 18,
  'Area Highlight': 19,
  'Distance': 20,
  'Perimeter': 21,
  'Area': 22,
  'Stamp': 23,
  'Image': 24,
  'Audio&Video': 25,
  'link': 26,
  'FileAttachment': 27,
  'Reply': 28,
  'Set Status': 29
}
export default class CollaborationAnnotEvent {
  constructor() {
    this.removeAddAnnotListener = () => {};
    this.removeUpdateAnnotListener = () => {};
    this.removeDeleteAnnotListener = () => {};
    this.removeAddAnnotReplyListener = () => {};
    this.removeAnnotReviewStateAdd = () => {}
    this.removeActiveAnnotListener = () => {};
    this.removeUnActiveAnnotListener = () => {};
  }

  annotAction = async ({ originAnnot, headerAnnot, eventType, isInitialAdd }, groupHeader) => {
    let promiseRes = []
    let annotsToUpload = originAnnot ? [originAnnot] : [headerAnnot]
    const { reviewSessionID } = store.collaborationStore;

    if (!reviewSessionID || !headerAnnot) {
      return;
    }
    if (!headerAnnot.getName()) {
      await headerAnnot.setUniqueID()
    }

    if (originAnnot && originAnnot.isReplace && originAnnot.isReplace()) {
      annotsToUpload.push(headerAnnot)
    }

    const uploadAnnot = async (originAnnot) => {
      let item = 'default item';
      let delFlag = 0;
      let updateDelFlag = false;
      const annot = annotExportToJSON(originAnnot)
      const annotName = annot.name;
      const pageIndex = annot.page;
      const pageObjNum = originAnnot.getPDFPage().getPageObjNum();
      const operandsActionType = this.getAnnotType(originAnnot.info);
      let operands;
      let operandsType;
  
      if (eventType === 'add') {
        operandsType = 1;

        // 发起者undo找回协作着被删的annot更新annot的delFlag
        if (store.collaborationStore.isAnnotInOwnerDeleteCollaboratorAnnotList(annotName)) {
          eventType = 'update'
          updateDelFlag = true
          delFlag = 0;
        }
      }
      if (eventType === 'update') {
        operandsType = 3;
      }
      if (eventType === 'delete') {
        operandsType = 2;
        delFlag = 1;
      }
  
      operands = JSON.stringify({
        Type: operandsActionType[0],
        ActionType: operandsType,
        // Content: annot.contents,
        Content: headerAnnot.getContent(),
        PageIndex: pageIndex,
      });
  
      let requestParam = {
        actionType: eventType,
        reviewSessionID,
        annotName,
        irt: headerAnnot.info.IRT,
        operands,
        annotType: operandsActionType[1],
        delFlag,
        pushAnnotAxiosTask: (task) => {
          store.collaborationStore.pushAnnotAxiosTaskArr(task)
        }
      }
  
      if (eventType !== 'delete') {
        if (originAnnot.isDeleted()) {
          return
        }
        
        const doc = await pdfui.getCurrentPDFDoc();
        const xfdfBlob = await doc.exportAnnotsToFDF(1, [originAnnot], false);
        const fr = new FileReader();
  
        fr.readAsText(xfdfBlob);
        item = await this.readAsText(fr);
        item = getAnnotFromXFDF(item)
        updateDelFlag === false && Object.assign(requestParam, {item, pageObjNum})
        this.addAnnotList({ item, annotName, delFlag })
      }
      if(eventType == 'delete'){
        this.deleteAnnotList({ actionType: eventType,reviewSessionID,annotName,operands,annotType: operandsActionType[1],delFlag,})
      }
  
      if (isInitialAdd) {
        const data = await collaborationApi.annotationAction(requestParam)
        if (data.ret !== 0) return;
        sendNotificationWithinTeams({ ...requestParam, pageIndex, content: headerAnnot.getContent() }, { originAnnot, groupHeader });
        return data
      }
  
      store.collaborationStore.pushAnnotTaskArr(requestParam)
  
      if (startAnnotTaskFlag) {
        clearTimeout(startAnnotTaskFlag)
      }
  
      startAnnotTaskFlag = setTimeout(() => {
        startAnnotTask()
      }, 500)
  
      const startAnnotTask = () => {
        const annotTaskParam = store.collaborationStore.shiftAnnotTaskArr()
  
        if (annotTaskParam) {
          collaborationApi.annotationAction(annotTaskParam).then(({ ret }) => {
            if (ret !== 0) return;
            sendNotificationWithinTeams({ ...annotTaskParam, pageIndex, content: headerAnnot.getContent() }, { originAnnot, groupHeader });
          }).catch(async () => {
            const { annotName } = annotTaskParam
            const annotPage = JSON.parse(annotTaskParam.operands).PageIndex
            const annotRender = await pdfui.getAnnotRender(annotPage, annotName)
  
            if (!annotRender) {
              return;
            }
  
            await annotRender.component.removeAnnot().catch((error) => {
              throw error;
            });
            store.appStore.setGlobalMessage({type: 'error', content: intl.get('collaboration.Error.operationCancelled')})
          }).finally(() => {
            this.removeAnnotAxiosTask(originAnnot)
            startAnnotTask()
          })
        }
      }
    }

    for (let i = 0; i < annotsToUpload.length; i++) {
      const originAnnot = annotsToUpload[i];
      
      promiseRes.push(await uploadAnnot(originAnnot))
    }
    
    return promiseRes
  };
  addAnnotList=({item,annotName,delFlag})=>{//addNewAnnot 时，更新collaborationStore中的 annotList
    const { userEmail, userMobile, cUserID} = store.collaborationStore.userInfo;
    let annotRenderInfo = getAnnotRenderInfo({annotItem:item, annotName:annotName, annotDelFlag:delFlag,userEmail: userEmail || userMobile,cUserID})
    store.collaborationStore.addAnnotList([annotRenderInfo])
  }
  deleteAnnotList=(deleteAnnot)=>{
    store.collaborationStore.deleteAnnotList([deleteAnnot])
  }

  addAnnotationReply = async (annot, groupHeader) => {
    const originAnnot = annot;
    const headerAnnot = annot;

    this.annotAction({ originAnnot, headerAnnot, eventType: 'add' }, groupHeader);
  };
  deleteAnnotation = async (annotArr) => {
    annotArr = annotArr.slice();
    
    const annots = this.getHeaderAndOriginAnnot(annotArr)
    // const annots = filterAnnotationData(annotArr)
    
    annots.forEach((annot) => {
      const {headerAnnot} = annot
      const annotName = headerAnnot.getName()
      
      // 发起者删除协作者的Annot
      if (!annot.$DELETE_LOCAL && store.collaborationStore.isShareReviewOwner() && !store.collaborationStore.isAnnotOwner(annotName)) {
        store.collaborationStore.updateIsOwnerDeleteCollaboratorAnnot(true)
        store.collaborationStore.updateOwnerDeleteCollaboratorAnnotList(annotName)
        // store.collaborationStore.removeAnnotFromOthersAnnotList(annotName)
      }
      
      if (!annot.$DELETE_LOCAL) {
        /*const isInAxiosProgress = */
        store.collaborationStore.annotAxiosTaskArr.some((axiosTask) => {
          if (axiosTask.annotName === headerAnnot.getName()) {
            let {cancelSource} = axiosTask

            cancelSource && cancelSource.cancel('user cancel upload annot')

            return true
          }
        })

        // if (!isInAxiosProgress) {
          this.annotAction({ headerAnnot, eventType: 'delete' })
        // }
      }
    })
  };
  updateAnnotation = async (annotArr, param, updateType) => {
    //console.log(param);

    let eventType = 'update'

    // 如果是reply，则不处理
    if (updateType === 'add-replies' || updateType === 'review-state-updated' || updateType === 'marked-state-updated') {
      return;
    }
    
    const annots = this.getHeaderAndOriginAnnot(annotArr)

    if (!annots.length) {
      return
    }

    if (updateAnnotShake) {
      clearTimeout(updateAnnotShake)
    }

    updateAnnotShake = setTimeout(() => {
      annots.forEach((annot) => {
        const {originAnnot, headerAnnot} = annot
  
        this.annotAction({ originAnnot, headerAnnot, eventType })
      })
    }, 500)
  };
  getHeaderAndOriginAnnot(annotArr) {
    annotArr = annotArr.slice(0)
    let pureAnnots
    let resultArr = []
    let groupedAnnotIndexArr = []
    let groupedAnnotIgnoreIndexArr = []

    // 获取replace标注的headerAnnot和originAnnot，并将此replace标注的其他元素加入groupedAnnotIgnoreIndexArr数组用于后续过滤
    annotArr.forEach((annot, index) => {
      if (annot.isGrouped && annot.isGrouped() && annot.isReplace && annot.isReplace()) {
        let annotObj = {}
        let { groupElements } = annot

        groupedAnnotIndexArr.push(index)
        groupElements.forEach((annotInner) => {
          if(annotInner.isGroupHeader()) {
            annotObj.headerAnnot = annotInner
          } else {
            annotObj.originAnnot = annotInner
            annotArr.some((annot, index) => {
              if (annotInner.id === annot.id) {
                groupedAnnotIgnoreIndexArr.push(index)

                return true
              }
            })
          }
        })
        
        resultArr.push(annotObj)
      }
    });
  
    // 过滤掉不需要的annot
    // let filterAnnotArr = [...groupedAnnotIndexArr, ...groupedAnnotIgnoreIndexArr]
    
    // for (let i = filterAnnotArr.length - 1; i >= 0; i--) {
    //   const annotIndex = filterAnnotArr[i];

    //   annotArr.splice(annotIndex, 1)
    // }

    // 将过滤剩余的annot加入resultArr
    pureAnnots = filterAnnotationData(annotArr)
    pureAnnots.forEach((pureAnnot) => {
      resultArr.push({headerAnnot: pureAnnot, originAnnot: pureAnnot})
    })

    //去除重复的annot
    let existAnnotArr = []

    for (let i = resultArr.length -1; i >= 0; i--) {
      const annot = resultArr[i];
      const headerAnnotId = annot.headerAnnot.id

      if (existAnnotArr.indexOf(headerAnnotId) > -1) {
        resultArr.splice(i, 1)
      } else {
        existAnnotArr.push(headerAnnotId)
      }
    }

    return resultArr
  }
  removeAnnotAxiosTask = (headerAnnot) => {
    store.collaborationStore.annotAxiosTaskArr.some((axiosTask, index) => {
      if (axiosTask.annotName === headerAnnot.getName()) {
        store.collaborationStore.spliceAnnotAxiosTaskArr(index)
      }
    })
  }
  addInitialAnnotations = async (annotArr) => {
    let promiseArr = []
    const annots = this.getHeaderAndOriginAnnot(annotArr)

    if (!annots.length) {
      return
    }

    for (let i = 0; i < annots.length; i++) {
      const annot = annots[i];
      const {originAnnot, headerAnnot} = annot
      const annotActionPromiseArr = await this.annotAction({ originAnnot, headerAnnot, eventType: 'add', isInitialAdd: true })

      promiseArr = [...promiseArr, ...annotActionPromiseArr];
    }

    return Promise.all(promiseArr)
  };
  addAnnotation = async (annotArr) => {
    let promiseArr = []
    const annots = this.getHeaderAndOriginAnnot(annotArr)

    if (!annots.length) {
      return
    }

    for (const annot of annots) {
      const {originAnnot, headerAnnot} = annot
      const annotActionPromiseArr = await this.annotAction({ originAnnot, headerAnnot, eventType: 'add' })

      promiseArr = [...promiseArr, ...annotActionPromiseArr]
    }

    return Promise.all(promiseArr)
  };
  annotReviewStateAdd = (annot) => {
    const headerAnnot = annot;

    return this.annotAction({ originAnnot: annot, headerAnnot, eventType: 'add' })
  }
  addAnnotationListener() {
    const uiEvents = UIExtension.UIEvents;

    this.removeAddAnnotListener = pdfui.addUIEventListener(uiEvents.annotationAdded, this.addAnnotation);
    this.removeAddAnnotReplyListener = pdfui.addUIEventListener(uiEvents.annotationReplyAdd, this.addAnnotationReply);
    this.removeUpdateAnnotListener = pdfui.addUIEventListener(uiEvents.annotationUpdated, this.updateAnnotation);
    this.removeDeleteAnnotListener = pdfui.addUIEventListener(uiEvents.annotationRemoved, this.deleteAnnotation);
    this.removeAnnotReviewStateAdd = pdfui.addUIEventListener(uiEvents.annotationReviewStateAnnotAdd, this.annotReviewStateAdd);
    this.removeActiveAnnotListener = pdfui.addUIEventListener(uiEvents.activeAnnotation, function (annotRender) {
      if (!annotRender) {
        return
      }
      
      const annotData = annotRender.annot && annotRender.annot.exportToJSON()

      store.collaborationStore.updateActiveAnnot(annotData)
    });
    this.removeUnActiveAnnotListener = pdfui.addUIEventListener(uiEvents.unActiveAnnotation, function (/* annotRender */) {
      store.collaborationStore.clearActiveAnnot()
    });
  }
  removeAnnotationListener() {
    this.removeAddAnnotListener()
    this.removeAddAnnotReplyListener()
    this.removeUpdateAnnotListener()
    this.removeDeleteAnnotListener()
    this.removeActiveAnnotListener()
    this.removeUnActiveAnnotListener()
    this.removeAnnotReviewStateAdd()
  }
  readAsText(fr) {
    return new Promise((resolve) => {
      fr.onload = function (e) {
        resolve(e.target.result);
      };
    });
  }
  getAnnotType(annotInfo) {
    // highlight
    if (annotInfo.type === 'highlight' && annotInfo.isArea === true) {
      return [annotNumberMap['Area Highlight'], 'Area Highlight'];
    }
    if (annotInfo.type === 'highlight' && annotInfo.isArea === false) {
      return [annotNumberMap['Highlight'], 'Highlight'];
    }

    // screen
    if (annotInfo.type === 'screen' && annotInfo.isAudioVideo === true) {
      return [annotNumberMap['Audio&Video'], 'Audio&Video'];
    }
    if (annotInfo.type === 'screen' && annotInfo.isAudioVideo === false) {
      return [annotNumberMap['Image'], 'Image'];
    }

    // text
    if (annotInfo.type === 'text' && annotInfo.isStateAnnot === false && annotInfo.RT === undefined) {
      return [annotNumberMap['Note'], 'Note'];
    }
    if (annotInfo.type === 'text' && annotInfo.isStateAnnot === false && annotInfo.RT === 'R') {
      return [annotNumberMap['Reply'], 'Reply'];
    }
    if (annotInfo.type === 'text' && annotInfo.isStateAnnot === true) {
      return [annotNumberMap['Set Status'], 'Set Status'];
    }

    // freetext
    if (annotInfo.type === 'freetext' && annotInfo.intent === "FreeTextTypewriter") {
      return [annotNumberMap['Typewriter'], 'Typewriter']
    }
    if (annotInfo.type === 'freetext' && annotInfo.intent === "") {
      return [annotNumberMap['Textbox'], 'Textbox']
    }
    if (annotInfo.type === 'freetext' && annotInfo.intent === "FreeTextCallout") {
      return [annotNumberMap['Callout'], 'Callout']
    }

    let annotType = annotTypeIndentMap[annotInfo.intent];

    if (annotType) {
      return [annotNumberMap[annotType], annotType];
    }

    annotType = annotTypeSubjectMap[annotInfo.subject];

    if (annotType) {
      return [annotNumberMap[annotType], annotType];
    }

    return [annotNumberMap[annotTypeMap[annotInfo.type]], annotTypeMap[annotInfo.type]];
  }
}
